import { useState } from "react";
import _ from "lodash";

import useMount from '../../hooks/useMount';
import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";

import { getLabel } from "../../tools/Dictionary";
import { MdAdd, MdRemove } from "react-icons/md";

const VariableDesignerTable = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const OnCloseModal = props.OnCloseModal;
  const OnSave = props.OnSave;
  const Data = props.Data;

  //State
  const [form, setForm] = useState({
    numberColumn: 3,
    numberRow: 1,
    column: ["Col1", "Col2", "Col3"],
    row: [
      ["", "", ""]
    ]
  });
  const [error] = useState({

  });
  const [loading] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm, setConfirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  useMount(() => {

    fillData();

  }, []);

  const fillData = () => {

    setForm(Data);

  };

  const onChangeNumberColumn = (e) => {

    let numberColumn = parseInt(e.target.value);

    //Max is 3 column
    if (numberColumn > 3) return;

    let tempRow = _.cloneDeep(form.row);
    let tempColumn = _.cloneDeep(form.column);

    //If number of Column is greater than before
    if (numberColumn > form.numberColumn){

      //Check each array of value
      tempRow.forEach(r => {

        //Add an empty string until enough column
        while (r.length < numberColumn){
          r.push("");
        }

      });

      //Add Column title 
      while (tempColumn.length < numberColumn){
        tempColumn.push("Col" + (tempColumn.length + 1));
      }

    }else{

      //Caculate how many column to remove
      let diff = form.numberColumn - numberColumn

      tempRow.forEach(r =>
      {
        //Remove the last column 
        r.splice(diff * -1, diff);

      });

      //Remove the last column title
      tempColumn.splice(diff * -1, diff);

    }


    setForm(form => ({
      ...form,
      numberColumn,
      row: tempRow,
      column: tempColumn
    }));

  };

  const onChangeColumnTitle = (e, index) => {

    let columnTitle = e.target.value;

    let tempColumn = _.cloneDeep(form.column);

    if (columnTitle.length > 20) return;

    try{

      tempColumn[index] = columnTitle;

      setForm(form => ({
        ...form,
        column: tempColumn
      }));

    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });
    
    }





  };

  const onChangeValue = (e, _row, _column) => {

    let row = e.target.value;

    let tempRow = _.cloneDeep(form.row);

    if (row.length > 99) return;

    try
    {

      tempRow[_row][_column] = row;

      setForm(form => ({
        ...form,
        row: tempRow
      }));

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }


  };

  const onClickAddRow = () => {

    if (form.numberRow> 99) return;

    let newRow = [];

    while (newRow.length < form.numberColumn)
    {
      newRow.push("");
    }



    setForm(form => ({
      ...form,
      numberRow: form.numberRow + 1,
      row: [...form.row, ...[newRow]]
    }));

  };

  const onClickRemoveRow = (e) => {

    try{

      if (form.numberRow <= 1) return;

      const indexRow = parseInt(e.currentTarget.dataset.row);

      setConfirm(confirm => ({
        Title: getLabel("App", "Delete"),
        Message: getLabel("VariableDesignerModal", "Are you sure you want to delete this row?"),
        Cancel: getLabel("App", "No"),
        onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
        Confirm: getLabel("App", "Yes"),
        onConfirm: () => onDeleteRow(indexRow),
        Display: true
      }));


    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

  };

  const onDeleteRow = (_row) => {

    try{

      setConfirm(confirm => ({ ...confirm, Display: false }))


      let tempRow = _.cloneDeep(form.row);

      tempRow.splice(_row, 1);

      setForm(form => ({
        ...form,
        numberRow: form.numberRow - 1,
        row: tempRow
      }));


    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });
    
    }

  };

  const onClickSave = async() => {

    try
    {

      OnSave(form);

      OnCloseModal();


    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }


  };



  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "860px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("VariableDesignerModal", "Table Variable")}
        </div>
        <div className="page_modal_body_cont">
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("VariableDesignerModal", "Number of columns")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "80px" }} >
              <select
                value={form.numberColumn}
                className={"page_select_input " + (error["numberColumn"] ? "auth_fill_row_input_error " : "")}
                onChange={onChangeNumberColumn}
                style={{ width: "100%", textAlign: "center", color: "black" }}
                disabled={!Access.canWrite || loading}
              >
                <option value={1}>1</option>
                <option value={2}>2</option>
                <option value={3}>3</option>
              </select>
              {error["numberColumn"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["numberColumn"]}
                </div>
              }
            </div>
          </div>
          <div className="variabledesigner_table_cont">
            <div className="variabledesigner_table_row">
              <div className="variabledesigner_table_label">
                {getLabel("VariableDesignerModal", "Column titles")}
              </div>
              {form.column.map((c, index) => (
                <div className="variabledesigner_table_item" key={index}> 
                  <input
                    className={"page_text_input " + (error["column" + index] ? "page_modal_body_col_input_error" : "")}
                    value={c || ""}
                    onChange={(e) => onChangeColumnTitle(e, index)}
                    type="text"
                    style={{ width: "100%" }}
                    disabled={!Access.canWrite || loading}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="variabledesigner_table_cont" style={{ marginBottom: "60px" }}>
            {form.row.map((row, indexRow) => (
              <div className="variabledesigner_table_row" key={indexRow}>
                <div className="variabledesigner_table_label">
                  {getLabel("VariableDesignerModal", "Row") + " #" + (indexRow + 1)}
                </div>
                {row.map((col, indexCol) => (
                  <div className="variabledesigner_table_item" key={indexCol}> 
                    <input
                      className={"page_text_input " + (error["row" + indexRow + indexCol] ? "page_modal_body_col_input_error" : "")}
                      value={col || ""}
                      onChange={(e) => onChangeValue(e, indexRow, indexCol)}
                      type="text"
                      style={{ width: "100%" }}
                      disabled={!Access.canWrite || loading}
                    />
                  </div>
                ))}
                <div className="variabledesigner_table_col">
                  <div className="page_button_round" style={{ height: "30px", width: "30px", backgroundColor: "#b30000" }}
                    data-row={indexRow}
                    title={getLabel("VariableDesignerModal", "Remove row")} onClick={onClickRemoveRow}>
                    <MdRemove />
                  </div>
                </div>
              </div>
            ))}
            <div className="variabledesigner_table_row" style={{height: "60px", marginTop: "10px", marginLeft: "20px"}}>
              <div className="page_button_round" title={getLabel("VariableDesignerModal", "Add row")} onClick={onClickAddRow}>
                  <MdAdd />
              </div>
            </div>
          </div>
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
          {!!Access.canWrite &&
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("App", "Confirm")}
              style={{ backgroundColor: "#52a3e7", maxWidth: "200px" }}
              onClick={(loading) ? undefined : onClickSave}
              disabled={loading}
            />
          } 
        </div>
      </div>
    </div>
  );

};

export default VariableDesignerTable